module.exports = __webpack_public_path__ + "media/images/download/e-book01-5765f542f44eb1ef73780b4a18f97e58.png";